<template>
  <div class="kpt-topbar">
    <div class="kpt-brand">
      <h5><a href="/"><img :src="getLogoImage()" alt="Kymeta Access" /></a></h5>
    </div>
    <div class="kpt-search">
      <search-component></search-component>
    </div>
    <div class="kpt-control-pane">
      <div class="control-buttons">
        <span class="kpt-maintenance-strip" v-if="showMaintenanceMode">
          Maintenance Mode ON
        </span>
        <span class="badge is-badge-small is-badge-danger notification-badge" :data-badge="$store.getters.unreadNotificationsCount" v-if="$store.getters.unreadNotificationsCount > 0">
          <b-icon :class="{ 'is-open': contextPane == 'notifications' }" icon="bell" size="is-medium" @click.native="openContextPane('notifications')"></b-icon>
        </span>
        <b-icon :class="{ 'is-open': contextPane == 'notifications' }" icon="bell" size="is-medium" @click.native="openContextPane('notifications')" v-else></b-icon>
        <!-- <b-icon :class="{ 'is-open': contextPane == 'settings' }" icon="cog" @click.native="openContextPane('settings')"></b-icon> -->
        <b-icon :class="{ 'is-open': contextPane == 'support' }" icon="user-headset" size="is-medium" @click.native="openContextPane('support')"></b-icon>
        <b-icon :class="{ 'is-open': contextPane == 'feedback' }" icon="smile" size="is-medium" @click.native="openContextPane('feedback')"></b-icon>
      </div>
      <b-dropdown position="is-bottom-left" ref="userPanel" style="position:relative" @active-change="$kya.event('system', 'userPanelDropdown', 'Clicked user icon')">
        <div class="kpt-user-panel has-cursor-pointer" slot="trigger">
          <div class="name-and-email is-size-7">
            <p class="truncate">{{user.firstName}} {{user.lastName}}</p>
            <p class="truncate">{{user.email}}</p>
          </div>
          <div class="user-icon">
            <b-icon icon="user-circle" size="is-medium"></b-icon>
          </div>
        </div>
        <b-dropdown-item custom paddingless :focusable="false" style="z-index:100">
          <user-panel-dropdown @closeuserpanel="toggleUserPanel"></user-panel-dropdown>
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>
<script>
import UserPanelDropdown from '../system/UserPanelDropdown.vue';
import SearchComponent from '../search/SearchComponent.vue';

export default {
  components: {
    UserPanelDropdown,
    SearchComponent
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    contextPane() {
      return this.$store.state.system.contextPane;
    },
    env() {
      return this.$store.state.appConfig.environment;
    },
    showMaintenanceMode() {
      return this.$store.state.maintenanceMode;
    }
  },
  methods: {
    openContextPane(name) {
      // KyAnalytics client plugin, event tracker
      this.$kya.event('system', 'paneOpen', 'Context pane opened', { contextPane: name });
      this.$store.commit('setContextPane', name);
    },
    toggleUserPanel() {
      this.$refs.userPanel.toggle();
    },
    getLogoImage() {
      // eslint-disable-next-line import/no-dynamic-require, global-require
      return require(`@/assets/access_logo_top${this.env == 'development' ? '_dev' : ''}.png`);
    }
  }
}
</script>
<style lang="scss" scoped>
  .kpt-topbar {
    height: 48px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .kpt-brand {
      padding-left: 1rem;
      user-select: none;
    }

    .kpt-search {
      width: 600px;
    }

    .kpt-maintenance-strip {
      width: 200px;
      padding: 5px;
      text-align: center;
      border: 1px solid red;
      background-color: red;
      color: white;
      font-weight: bold;
    }

    .kpt-control-pane {
      padding-right: 1rem;
      display: flex;
      user-select: none;

      .control-buttons {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-right: 1.5rem;
        //width: 100px;

        span.icon:hover {
          cursor: pointer;
        }

        .icon {
          height: 48px;
          width: 42px;
        }
      }

      .kpt-user-panel {
        text-align: right;
        line-height: 1rem;
        display: flex;
        width: 155px;
        height: 48px;
        align-items: center;

        .name-and-email {
          p.truncate {
            width: 130px;
          }
        }
      }
    }
  }
</style>
